import type { PropsWithChildren } from "react";
import { useParams } from "react-router";
import type { LinkProps } from "react-router-dom";
import { Link } from "react-router-dom";

/**
 * Package-local copy of `frontend/src/components/common/TenantAwareLink.tsx`,
 * since it's used outside the `Install.tsx` sibling-injection mechanism.
 */
export const TenantAwareLink: React.FC<
  PropsWithChildren<Omit<LinkProps, "to"> & { to: string }>
> = ({ to, children, ...rest }) => {
  const { orgSlug } = useParams();
  return (
    <Link to={`/o/${orgSlug}/${to}`} {...rest}>
      {children}
    </Link>
  );
};
